import { auditSupport } from '@mi-front/api-clients';
import { MrtTable } from '@mi-front/ui';
import { Box } from '@mui/material';
import { type MRT_Cell, type MRT_ColumnDef, type MRT_Row } from 'material-react-table';
import { useIntl } from 'react-intl';
import { LDate } from '../../../../../../components/date/LDate';
import { LTime } from '../../../../../../components/date/LTime';

export type AvgPreviewProps = {
  entries: auditSupport.AvgEntryDto[];
};

export function AvgPreview({ entries }: AvgPreviewProps) {
  const { $t } = useIntl();

  const columns: MRT_ColumnDef<auditSupport.AvgEntryDto>[] = [
    {
      accessorKey: 'index',
      header: $t({ id: 'common.columnIndex', defaultMessage: '#' }),
      size: 50,
      Cell: ({ row }: { row: MRT_Row<auditSupport.AvgEntryDto> }) => row.index + 1,
      enableSorting: false,
      enableColumnFilter: false,
    },
    {
      accessorKey: 'datetime',
      header: $t({
        id: 'common.datetime',
        defaultMessage: 'Fecha y hora',
      }),
      size: 200,
      Cell: ({ cell }: { cell: MRT_Cell<auditSupport.AvgEntryDto, unknown> }) => (
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <LDate value={cell.getValue() as string} day="2-digit" month="2-digit" year="2-digit" />
          <LTime value={cell.getValue() as string} second="numeric" />
        </div>
      ),
    },
    {
      accessorKey: 'type',
      header: $t({ id: 'common.type', defaultMessage: 'Tipo' }),
      size: 150,
    },
    {
      accessorKey: 'customId',
      header: $t({
        id: 'common.customId',
        defaultMessage: 'ID personalizado',
      }),
      size: 200,
    },
    {
      accessorKey: 'name',
      header: $t({ id: 'common.name', defaultMessage: 'Nombre' }),
      size: 250,
    },
  ];

  return (
    <Box mt={3}>
      <MrtTable
        columns={columns}
        data={entries}
        enableSorting
        enableColumnFilters
        enableGlobalFilter
        initialState={{
          density: 'compact',
          pagination: { pageSize: 50, pageIndex: 0 },
        }}
      />
    </Box>
  );
}
